/**
 * Search
 *
 * Focuses the search input when the search popover opens.
 */
import { trapFocus } from './utils';

const search = document.getElementById('site-search');
const searchInput = search.querySelector('input');
let releaseSearchFocusTrap = null;

search.addEventListener('toggle', e => {
    if (e.newState === 'open') {
        searchInput.focus();
        releaseSearchFocusTrap = trapFocus(search, false);
    } else {
        releaseSearchFocusTrap?.();
        releaseSearchFocusTrap = null;
    }
});
